const MAX_BUCKET_NAME_LENGTH = 64;
const VALID_BUCKET_NAME_PATTERN = /^[a-z0-9](?:[a-z0-9_-]*[a-z0-9])?$/;

export async function getValidStorageBucketName(name: string): Promise<string> {
    const normalizedName = name.toLowerCase();
    if (normalizedName.length <= MAX_BUCKET_NAME_LENGTH &&
        VALID_BUCKET_NAME_PATTERN.test(normalizedName)) {
        return normalizedName;
    }
    
    const msgUint8 = new TextEncoder().encode(name) as Uint8Array<ArrayBuffer>;
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8);
    return Array.from(new Uint8Array(hashBuffer), b => b.toString(16).padStart(2, "0")).join("");
}
